$(document).ready(function() {
    const productOptions = window.productOptions || [];
    let startY = null; // To track the initial scroll position
    let startX = null;

    if (productOptions.length === 0) {
        console.error("No product options found.");
    }

    function convertToHtml(content) {
        let html = "";
        if (content.type === 'text') {
            html += content.bold ? `<strong>${content.value}</strong>` : content.value;
        } else if (content.type === 'paragraph') {
            html += "<p>";
            content.children.forEach(child => html += convertToHtml(child));
            html += "</p>";
        } else if (content.type === 'list') {
            html += content.listType === 'unordered' ? "<ul>" : "<ol>";
            content.children.forEach(child => html += `<li>${convertToHtml(child)}</li>`);
            html += content.listType === 'unordered' ? "</ul>" : "</ol>";
        } else if (content.type === 'list-item') {
            content.children.forEach(child => html += convertToHtml(child));
        } else if (content.type === 'link') {
            html += `<a href="${content.url}" title="${content.title}">`;
            content.children.forEach(child => html += convertToHtml(child));
            html += "</a>";
        } else if (content.type === 'root') {
            content.children.forEach(child => html += convertToHtml(child));
        }
        return html;
    }

    // Create the flyout panel if it doesn't exist
    if ($('#flyout-panel').length === 0) {
        $('body').append(`
            <div id="flyout-panel" class="flyout-panel">
                <div class="flyout-panel__header">
                    <div class="close flyout-panel__close-btn">&times;</div>
                </div>
                <div class="content flyout-panel__content"></div>
            </div>
        `);
    }

    function handleSwipe(event) {
        const touch = event.changedTouches[0];
        const distX = touch.clientX - startX;

        if (distX > 50) { // Swipe right to close
            $('#flyout-panel').removeClass('open');
            $(document).off('click.flyoutPanel');
            startX = null;
        }
    }

    function handleScroll() {
        const scrollThreshold = 100; // Adjust this value to set the scroll distance threshold
        if (startY === null) {
            startY = window.scrollY;
        }
        const distY = Math.abs(window.scrollY - startY);

        if (distY > scrollThreshold) {
            $('#flyout-panel').removeClass('open');
            $(document).off('click.flyoutPanel');
            startY = null; // Reset startY after closing the panel
        }
    }

    function addTooltipEventListeners() {
        // --- Flyout open handler ---
        // Delegated from document so it also fires for option rows that Bold
        // injects/re-renders later (e.g. the out-of-stock BALANCE-TEC row).
        $(document).off("click.optFlyout").on("click.optFlyout",
            ".bold_tooltip, .bold_option_title, .bold_option_value_price",
            function(event) {
                event.preventDefault();
                event.stopPropagation();
                event.stopImmediatePropagation();

                var titleElement = $(this).closest('.bold_option').find('.bold_option_title');
                var titleText = titleElement.text().trim() || '';

                var productOption = productOptions.find(option => option.heading.trim() === titleText);
                if (productOption) {
                    var htmlContent = convertToHtml(productOption.text);
                    var imageUrl = productOption.option_image;
                    var headingForFlyout = productOption.heading_for_flyout || '';
                    var preOrderNote = productOption.pre_order_note || '';
                    var optionNote = productOption.option_note || '';

                    // Check for the existence of bold_option_value_price
                    var priceElement = $(this).closest('.bold_option').find('.bold_option_value_price');
                    var priceText = '';
                    if (productOption.price_text) {
                        priceText = `<p class="product-info__price price__default"><strong>${productOption.price_text}</strong></p>`;
                    } else if (priceElement.length) {
                        priceText = `<p class="product-info__price price__default"><strong>${priceElement.text().trim()}</strong></p>`;
                    }

                    if (htmlContent) {
                        var combinedContent = `
                            <img src="${imageUrl}" alt="${productOption.heading}" style="max-width:100%; height:auto;">
                            <h6>${headingForFlyout}</h6>
                            ${priceText}
                            ${htmlContent}
                            ${preOrderNote ? `<p class="pre-order-note"><b>Preorder:</b> ${preOrderNote}</p>` : ''}
                            ${optionNote ? `<p class="option-note"><b>Note:</b> ${optionNote}</p>` : ''}
                        `;
                        $('#flyout-panel .flyout-panel__content').html(combinedContent);
                        $('#flyout-panel').addClass('open');
                        startY = window.scrollY; // Set the initial scroll position when the panel is opened
                    }

                    $(document).on('click.flyoutPanel', function(event) {
                        if (!$(event.target).closest('#flyout-panel, .bold_tooltip').length) {
                            $('#flyout-panel').removeClass('open');
                            $(document).off('click.flyoutPanel');
                        }
                    });

                    $(window).on('scroll.flyoutPanel', handleScroll); // Attach scroll event handler
                }
            });

        // --- Per-option setup ---
        // Runs once per matched element: injects the metafield price / pre-order
        // note into each row, and swallows hover events. (This is the block that
        // used to live inside the old .each() alongside the click binding.)
        $(".bold_tooltip, .bold_option_title, .bold_option_value_price").each(function(index, element) {
            var titleElement = $(this).closest('.bold_option').find('.bold_option_title');
            var titleText = titleElement.text().trim() || '';
            var productOption = productOptions.find(option => option.heading.trim() === titleText);

            if (productOption) {
                var priceElement = $(this).closest('.bold_option').find('.bold_option_value_price');

                // If we have a price in the metafield (price_text), use it regardless of Bold price
                if (productOption.price_text) {
                    if (priceElement.length) {
                        // Replace existing Bold price with metafield price
                        priceElement.html(` ${productOption.price_text}`);
                    } else {
                        // Add metafield price if no price element exists
                        titleElement.after(`<span class="bold_option_value_price"> ${productOption.price_text}</span>`);
                    }
                }

                // Move pre_order_note after bold_tooltip if it exists and hasn't been added yet
                if (productOption.pre_order_note && !titleElement.closest('.bold_option').find('.pre-order-note').length) {
                    titleElement.closest('.bold_option').find('.bold_tooltip').after(`<font size="1">
            <div class="pre-order-note" style="margin-left: 30px; display: block; color: grey;">
                <b>Pre-Order:</b> ${productOption.pre_order_note}
            </div>
        </font>`);
                }
            }
            // NOTE: the inline option_note is handled separately by
            // injectOptionNotes() below, so it also survives on out-of-stock rows
            // (which Bold re-renders without a .bold_tooltip).

            $(element).off('mouseenter mouseleave').on('mouseenter mouseleave', function(event) {
                event.stopPropagation();
                event.stopImmediatePropagation();
            });
        });

        // Check if any checked option has a pre_order_note and add text under the Add to Cart button
        function updatePreOrderText() {
            let preOrderTextAdded = false;
            let preOrderMessage = '';

            $('.bold_option input[type="checkbox"]').each(function() {
                var titleElement = $(this).closest('.bold_option').find('.bold_option_title');
                var titleText = titleElement.text().trim() || '';

                var productOption = productOptions.find(option => option.heading.trim() === titleText);
                if (productOption && productOption.pre_order_note && $(this).is(':checked')) {
                    preOrderTextAdded = true;
                    preOrderMessage += `Pre-order: ${titleText} ${productOption.pre_order_note}<br>`;
                }
            });

            if (preOrderTextAdded) {
                if ($('#pre-order-text').length === 0) {
                    $('.product-info__add-button .bold_clone').after('<div id="pre-order-text" style="font-weight:bold;">' + preOrderMessage + '</div>');
                } else {
                    $('#pre-order-text').html(preOrderMessage);
                }
            } else {
                $('#pre-order-text').remove();
            }
        }

        // Bind the updatePreOrderText function to checkbox change events
        $('.bold_option input[type="checkbox"]').on('change', updatePreOrderText);

        // Initial call to update the text based on the current state of the checkboxes
        updatePreOrderText();

        // Modify form submission to include pre-order note in line item properties
        $('form').on('submit', function(event) {
            let preOrderProperties = [];
            $('.bold_option input[type="checkbox"]').each(function() {
                var titleElement = $(this).closest('.bold_option').find('.bold_option_title');
                var titleText = titleElement.text().trim() || '';
                var productOption = productOptions.find(option => option.heading.trim() === titleText);
                if (productOption && productOption.pre_order_note && $(this).is(':checked')) {
                    preOrderProperties.push({
                        'name': `Pre-order: ${titleText}`,
                        'value': productOption.pre_order_note
                    });
                }
            });

            if (preOrderProperties.length > 0) {
                event.preventDefault();
                var form = $(this);
                var formData = form.serializeArray();

                preOrderProperties.forEach(property => {
                    formData.push({ name: `properties[${property.name}]`, value: property.value });
                });

                $.post(form.attr('action'), formData, function(response) {
                    // Handle successful form submission (e.g., redirect to cart page)
                    window.location.href = '/cart';
                });
            }
        });
    }

    addTooltipEventListeners();

    $(document).on('click', '#flyout-panel .flyout-panel__close-btn', function() {
        $('#flyout-panel').removeClass('open');
        $(document).off('click.flyoutPanel');
        $(window).off('scroll.flyoutPanel'); // Detach scroll event handler when panel is closed
    });

    $('#flyout-panel').on('touchstart', function(event) {
        const touch = event.touches[0];
        startX = touch.clientX;
        startY = touch.clientY;
    });

    $('#flyout-panel').on('touchmove', function(event) {
        if (startX === null || startY === null) {
            return;
        }

        const touch = event.touches[0];
        const distX = touch.clientX - startX;
        const distY = touch.clientY - startY;

        // Close on any significant swipe (adjust the threshold as needed)
        if (distX > 50 && Math.abs(distY) < Math.abs(distX)) {
            closeFlyoutPanel();
            event.preventDefault(); // Prevent scrolling
        }
    });

    $('#flyout-panel').on('touchend', function() {
        startX = null;
        startY = null;
    });

    function closeFlyoutPanel() {
        $('#flyout-panel').removeClass('open');
        $(document).off('click.flyoutPanel');
        $(window).off('scroll.flyoutPanel');
        startX = null;
        startY = null;
    }

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) {
                    if (node.matches('.bold_tooltip')) {
                        addTooltipEventListeners();
                    }
                    if (node.querySelectorAll) {
                        const tooltipChildren = node.querySelectorAll('.bold_tooltip');
                        if (tooltipChildren.length > 0) {
                            addTooltipEventListeners();
                        }
                    }
                }
            });
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // --- Inline option note ---
    // Renders productOption.option_note as a small line under each matching
    // option row. Runs on its own observer, independent of the tooltip logic,
    // so it ALSO injects into out-of-stock rows — which Bold re-renders without
    // a .bold_tooltip (the reason the earlier in-.each approach missed them).
    // Idempotent: guarded against duplicate insertion.
    function injectOptionNotes() {
        document.querySelectorAll('.bold_option').forEach(function(row) {
            var titleEl = row.querySelector('.bold_option_title');
            if (!titleEl) return;
            var titleText = titleEl.textContent.trim();
            var productOption = productOptions.find(function(o) { return o.heading.trim() === titleText; });
            if (productOption && productOption.option_note && !row.querySelector('.option-note-inline')) {
                var note = document.createElement('div');
                note.className = 'option-note-inline';
                note.setAttribute('style', 'margin-left: 30px; display: block; color: #666; font-size: 0.7em;');
                note.textContent = productOption.option_note;
                row.appendChild(note);
            }
        });
    }

    injectOptionNotes();
    new MutationObserver(injectOptionNotes).observe(document.body, { childList: true, subtree: true });
});

/*** Start Bold Options Help Text Script ***/
(function() {
  // Create a function to add our help text
  function addHelpText() {
    const productTitle = document.querySelector('.bold_option_product_title');
    if (productTitle && !document.querySelector('.bold-help-text')) {  // Check if help text already exists
      const helpText = document.createElement('div');
      helpText.className = 'bold-help-text';  // Add class to prevent duplicate insertion

      // Create the content with SVG and text
      helpText.innerHTML = `
        <div style="display: flex; align-items: center; justify-content: center; gap: 8px;">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style="width: 20px; height: 20px; fill: #666;">
            <g>
              <path d="M397.491,219.415c-5.54,0-10.838,1.042-15.723,2.923c-5.403-18.122-22.212-31.377-42.067-31.377   c-5.711,0-11.165,1.108-16.174,3.101c-5.838-17.393-22.281-29.965-41.616-29.965c-4.856,0-9.525,0.804-13.895,2.267v-46.47   c0-24.203-19.691-43.895-43.895-43.895s-43.895,19.691-43.895,43.895v189.863l-17.144-25.448l-0.398-0.495   c-16.801-20.884-46.358-25.525-68.751-10.794c-11.709,7.703-19.642,19.52-22.337,33.273c-2.676,13.656,0.15,27.494,7.958,38.998   l76.406,120.437l0.301,0.457C175.965,494.873,208.505,512,243.308,512h85.751c61.938,0,112.327-50.39,112.327-112.327V263.311   C441.386,239.106,421.695,219.415,397.491,219.415z M411.386,399.673c0,45.396-36.932,82.327-82.327,82.327h-85.751   c-24.829,0-48.048-12.175-62.168-32.583L104.753,329.01l-0.301-0.457c-3.334-4.854-4.546-10.71-3.414-16.489   c1.133-5.778,4.466-10.744,9.386-13.98c9.254-6.089,21.419-4.301,28.535,4.107l71.27,105.796V119.895   c0-7.661,6.233-13.895,13.895-13.895s13.895,6.233,13.895,13.895V269.79h30v-61.798c0-7.661,6.233-13.895,13.895-13.895   s13.895,6.233,13.895,13.895v61.798h30v-34.935c0-7.661,6.233-13.895,13.895-13.895s13.895,6.233,13.895,13.895v34.935h30v-5.296   v-1.184c0-7.662,6.233-13.896,13.895-13.896s13.895,6.233,13.895,13.896V399.673z"></path>
              <rect x="208.284" width="30" height="41.5"></rect>
              <rect x="261.832" y="28.147" transform="matrix(0.6736 -0.7391 0.7391 0.6736 60.3529 222.949)" width="41.5" height="30"></rect>
              <rect x="290.574" y="84.644" transform="matrix(0.9957 -0.0926 0.0926 0.9957 -7.8875 29.2482)" width="41.5" height="30"></rect>
              <rect x="148.06" y="22.397" transform="matrix(0.7391 -0.6736 0.6736 0.7391 13.4755 121.0881)" width="30" height="41.5"></rect>
              <rect x="119.318" y="78.894" transform="matrix(0.0926 -0.9957 0.9957 0.0926 22.6684 224.1608)" width="30" height="41.5"></rect>
            </g>
          </svg>
          <span>Click options for more info</span>
        </div>
      `;

      helpText.style.cssText = `
        color: #444;
        font-size: 14px;
        margin: 10px 0;
        padding: 8px;
        background-color: #f8f9fa;
        border-radius: 4px;
        text-align: center;
      `;

      productTitle.insertAdjacentElement('afterend', helpText);
    }
  }

  // Create a MutationObserver to watch for Bold Options content
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (document.querySelector('.bold_option_product_title')) {
        addHelpText();
      }
    });
  });

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Also try to add the help text on initial load
  document.addEventListener('DOMContentLoaded', addHelpText);

  // And after a short delay (as backup)
  setTimeout(addHelpText, 1000);
})();
/*** End Bold Options Help Text Script ***/
